import { useEffect, useMemo, useState } from "react";
import { Radio, Users, Tag, Music2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { usePlayer } from "@/context/PlayerContext";
import { api } from "@/lib/api";

export const LibraryRadio = () => {
  const p = usePlayer();
  const [facets, setFacets] = useState({ artists: [], genres: [] });
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/library/facets").then((r) => setFacets(r.data)); }, []);
  const matches = useMemo(() => {
    const s = q.trim().toLowerCase();
    return s ? facets.artists.filter((a) => a.toLowerCase().includes(s)).slice(0, 8) : [];
  }, [q, facets.artists]);
  const genres = useMemo(() => [...new Map(facets.genres.map((g) => [g.toLowerCase(), g])).values()].slice(0, 30), [facets.genres]);

  return (
    <div className="grid gap-10 lg:grid-cols-2">
      <section>
        <h3 className="flex items-center gap-2 text-lg font-medium"><Users size={17} className="text-amber-600" />Artist radio</h3>
        <p className="mb-4 mt-1 text-sm text-zinc-500">Endless music from an artist and the artists in your library that sound like them (picked by AI).</p>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Find an artist in your library…" className="h-11" data-testid="library-radio-artist-input" />
        <div className="mt-2 divide-y divide-zinc-100 rounded-lg border border-zinc-200 bg-white empty:hidden">
          {matches.map((a) => (
            <button key={a} onClick={() => p.startRadio("artist", a)} data-testid={`library-radio-artist-${a.replace(/\s+/g, "-")}`}
              className="flex w-full items-center justify-between px-4 py-2.5 text-left text-sm hover:bg-zinc-50">
              {a}<span className="flex items-center gap-1 text-xs text-amber-700"><Radio size={13} />Start radio</span>
            </button>
          ))}
        </div>
        <p className="mt-6 flex items-start gap-2 rounded-md bg-zinc-100/70 px-4 py-3 text-xs text-zinc-600">
          <Music2 size={14} className="mt-0.5 shrink-0" />Song radio: open the <b className="mx-0.5">⋯</b> menu on any song and choose <b className="mx-0.5">Start song radio</b>. Artist pages also have an <b className="mx-0.5">Artist radio</b> button.
        </p>
      </section>
      <section>
        <h3 className="flex items-center gap-2 text-lg font-medium"><Tag size={17} className="text-amber-600" />Genre radio</h3>
        <p className="mb-4 mt-1 text-sm text-zinc-500">A never-ending shuffle of one genre from your collection.</p>
        <div className="flex flex-wrap gap-2" data-testid="library-radio-genres">
          {genres.length === 0 && <p className="text-sm text-zinc-500">No genres in your library yet.</p>}
          {genres.map((g) => (
            <button key={g} onClick={() => p.startRadio("genre", g)} data-testid={`library-radio-genre-${g.replace(/\s+/g, "-")}`}
              className="flex items-center gap-1.5 rounded-full bg-white px-4 py-2 text-sm ring-1 ring-zinc-200 transition-colors hover:bg-zinc-900 hover:text-white hover:ring-zinc-900">
              <Radio size={13} />{g}
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};
